import React from 'react'
import {Alert, Button, IconButton, Snackbar} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import {makeStyles} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  error: {
    color: "white",
    backgroundColor: "red"
  },
  success: {
    color: "white",
    backgroundColor: "green"
  },
  warning: {
    color: "black",
    backgroundColor: "orange"
  },
  info: {
    color: "white",
    backgroundColor: "blue"
  }
}));

const ATSnackbar = ({message, open, setOpen, severity}) => {
  const classes = useStyles();
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  const action = (
    <React.Fragment>
      <Button color="secondary" size="small" onClick={handleClose}>
        CLOSE
      </Button>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleClose}
      >
        <CloseIcon fontSize="small"/>
      </IconButton>
    </React.Fragment>
  );

  return (
    <Snackbar
      open={open}
      autoHideDuration={6000}
      onClose={handleClose}
      action={action}
      color={severity}
      anchorOrigin={{vertical: 'top', horizontal: 'right'}}
    >
      <Alert
        onClose={handleClose}
        variant="filled"
        severity={severity}
        color={severity}
        sx={{width: '100%'}}
        className={classes[severity]}
      >
        {message}
      </Alert>
    </Snackbar>
  )
}

export default ATSnackbar